import { PayloadAction, createSlice } from '@reduxjs/toolkit';

import { RequestStatus } from '@app/constants';
import { IRequestFailed } from '@app/types';
import { IBoardDetail, IMyTasksState, TaskQueryParams } from './type';

const initialState: IMyTasksState = {
  myTasks: {},
  myTaskDetails: {},
  updateTaskStatus: {},
};

const slice = createSlice({
  name: 'myTasks',
  initialState,
  reducers: {
    getMyTasks(state, action: PayloadAction<TaskQueryParams>) {
      state.myTasks.status = RequestStatus.RUNNING;
    },
    getMyTasksSuccess(state, action: PayloadAction<IMyTasksState['myTasks']['data']>) {
      state.myTasks.status = RequestStatus.SUCCESS;
      state.myTasks.data = action.payload;
    },
    getMyTasksFailed(state, action: PayloadAction<IRequestFailed>) {
      state.myTasks.status = RequestStatus.ERROR;
      state.myTasks.error = action.payload;
    },
    //
    getMyTaskDetails(state, action: PayloadAction<IBoardDetail>) {
      state.myTaskDetails.status = RequestStatus.RUNNING;
    },
    getMyTaskDetailsSuccess(state, action: PayloadAction<IMyTasksState['myTaskDetails']['data']>) {
      state.myTaskDetails.status = RequestStatus.SUCCESS;
      state.myTaskDetails.data = action.payload;
    },
    getMyTaksDetailsFailed(state, action: PayloadAction<IRequestFailed>) {
      state.myTaskDetails.status = RequestStatus.ERROR;
      state.myTaskDetails.error = action.payload;
    },
    //
    updateTaskStatus(state, action: PayloadAction<any>) {
      state.updateTaskStatus.status = RequestStatus.RUNNING;
    },
    updateTaskStatusSuccess(state, action: PayloadAction<IMyTasksState>) {
      state.updateTaskStatus.status = RequestStatus.SUCCESS;
      state.updateTaskStatus.data = action.payload;
    },
    updateTaskStatusFailed(state, action: PayloadAction<IRequestFailed>) {
      state.updateTaskStatus.status = RequestStatus.ERROR;
      state.updateTaskStatus.error = action.payload;
    },
  },
});
export default slice.reducer;

export const {
  getMyTasks,
  getMyTasksSuccess,
  getMyTasksFailed,
  getMyTaskDetails,
  getMyTaskDetailsSuccess,
  getMyTaksDetailsFailed,
  updateTaskStatus,
  updateTaskStatusFailed,
  updateTaskStatusSuccess,
} = slice.actions;
